<div mat-dialog-title class="d-flex justify-content-between align-items-center">
    <h2 class="m-0">Bill / Invoice type
    </h2>
    <button mat-icon-button mat-dialog-close>
      <mat-icon>close</mat-icon>
    </button>
  </div>
  <mat-dialog-content>
<div class="bill_invoice_sec">
    <div class="cart_list_open">
        <mat-radio-group aria-label="Select an option" [(ngModel)]="billInvoiceType">
            
          <div class="ind_c">
            <mat-radio-button [value]="1">TAX INCLUSIVE</mat-radio-button>
            <p>Tax included in selling price</p>
            
          </div>
          <div class="ind_c">
            <mat-radio-button [value]="2">TAX EXCLUSIVE </mat-radio-button>
            <p>Tax added extra in selling price</p>
            
          </div>
        </mat-radio-group>   
    </div>

    <!-- <div class="cart_list_open">
        <mat-radio-group aria-label="Select an option">
          </mat-radio-group>   
    </div> -->
</div>
  </mat-dialog-content>

<mat-dialog-actions align="end">
    <button mat-button mat-dialog-close > Cancel </button>
    <button mat-flat-button color="accent" (click)="onSave()" [disabled]="!billInvoiceType || billInvoiceType == null"> Save </button>
</mat-dialog-actions>